// Services dont le feedback produit est désactivé, par customerId
export const FEEDBACK_DISABLED_SERVICES: Record<string, string[]> = {
  MPR: ['GO'], // Terra : restaurant non exploité par le client
};
